import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AlertService } from "app/services/style/alert.service";
import { animate, style, transition, trigger } from "@angular/animations";

@Component({
  selector: "app-alert",
  imports: [CommonModule],
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
  animations: [
    trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateY(100%)", opacity: 0 }),
        animate("300ms ease-out", style({ transform: "translateY(0)", opacity: 1 })),
      ]),
      transition(":leave", [
        style({ transform: "translateY(0)", opacity: 1 }),
        animate("200ms ease-in", style({ transform: "translateY(100%)", opacity: 0 })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  private alertService = inject(AlertService);
  public readonly alerts = this.alertService.alerts;

  public getIconClass(type: string): string {
    switch (type) {
      case "success":
        return "fas fa-check-circle";
      case "error":
        return "fas fa-exclamation-circle";
      case "warning":
        return "fas fa-exclamation-triangle";
      case "info":
        return "fas fa-info-circle";
      default:
        return "fas fa-info-circle";
    }
  }

  public dismissAlert(id: number): void {
    this.alertService.removeAlert(id);
  }
}
